<i18n>
{
  "en": {
    "back": "Back",
    "selectMessage": "Select a restaurant to view its details"
  },
  "es": {
    "back": "Atrás",
    "selectMessage": "Elige un restaurante para ver sus detalles"
  }
}
</i18n>
<template>
  <v-container class="mb-10">
    <div class="text-center font-weight-bold ma-1 mb-5 text-md-h6 text-body-1">{{$t('selectMessage')}}</div>
    <div class="d-flex flex-wrap justify-center" v-if="shouldShowGrid" :style="cssVar">
      <completion-by-pos-widget v-for="pointOfSale in pointOfSalesToShow"
                                :key="pointOfSale.guid" :name="pointOfSale.name"
                                :value="profileCompletionByGuid(pointOfSale.guid).percentage"
                                :icon="iconByPos(pointOfSale)"
                                @click="onDetail(pointOfSale.guid)"
                                class="grid-center-x grid-center-y text-center | widget"/>
    </div>
    <dynameat-confirmation-buttons :confirm-visible="false" :cancel-text="$t('back')" @cancel="onBack"
    class="ml-4"/>
  </v-container>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import DynameatConfirmationButtons from '@dynameat/components/DynameatConfirmationButtons';
import CompletionByPosWidget from './components/CompletionByPosWidget.vue';

@Component
@MapGetters(['pointOfSaleList', 'profileCompletionList'])
@Components({ CompletionByPosWidget, DynameatConfirmationButtons })
@MapActions(['setSelectedPointOfSaleGuid'])
export default class CompletionByPos extends Vue {
  get customGridClass() {
    return { 'custom-grid': this.$vuetify.breakpoint.mobile, 'custom-grid-desktop': !this.$vuetify.breakpoint.mobile };
  }

  get cssVar() {
    return `--points-of-sale: ${this.pointOfSaleList.length}`;
  }

  get shouldShowGrid() {
    return this.profileCompletionList.length > 0;
  }

  get pointOfSalesToShow() {
    return this.pointOfSaleList.filter((pos) => this.profileCompletionByGuid(pos.guid) !== undefined);
  }

  profileCompletionByGuid(guid) {
    return this.profileCompletionList.find((completion) => completion.pointOfSale === guid);
  }

  iconByPos(pos) {
    return pos.isManaged ? { color: 'green', value: 'mdi-currency-usd-circle-outline' } : null;
  }

  onDetail(pointOfSaleGuid) {
    this.$router.push({ name: 'completion-detail', params: { pointOfSaleGuid } });
    this.setSelectedPointOfSaleGuid(pointOfSaleGuid);
  }

  onBack() {
    this.$router.push({ name: 'profile' });
  }
}
</script>
<style scoped>
.custom-grid {
  row-gap: 20px;
  column-gap: 0;
  grid: auto-flow / 1fr 1fr;
}

.custom-grid-desktop {
  --points-of-sale: 5;
  grid: 1fr / repeat(var(--points-of-sale), 1fr);
}

.widget {
  height: 100%;
}
</style>
